import { useState } from "react"
import { useQuery } from "@tanstack/react-query"
// NOTE: components
import Card from '../ui/Card'
import ResourcesModal from '../resources/ResourcesModal'
import loadImage from '../../utils/loadImage'
import PdfThumbnail from '../pdfThumbnail/PdfThumbnail'

interface ResourcesModalProps {
	pdf: any
	cover: any
	title: string
	dek: string
	className?: string
	thumbnailClassName: string
}

const ResourcesCard = ({ pdf, cover, title, dek, className, thumbnailClassName }: ResourcesModalProps) => {
	const [show, setShow] = useState(false)
	const handleClose = () => setShow(false)
	const handleShow = () => setShow(true)

	const { isLoading: isLoadingImg, isError: isErrorImg, error: errorImg, data: imageUrl } = useQuery({
		queryKey: ['resourcesImg', cover?.url],
		queryFn: async () => {
			const response = await fetch(`/api/cms${cover.url}`)

			await loadImage(response)

			return response.url ?? null
		},
		enabled: !!cover?.url
	})

	const { isLoading: isLoadingPdfFile, isError: isErrorPdfFile, error: errorPdfFile, data: pdfFile } = useQuery({
		queryKey: ['resourcePdf', pdf?.url],
		queryFn: async () => {
			const response = await fetch(`/api/cms${pdf?.url}`)

			return response.url ?? null
		},
		enabled: !!pdf?.url
	})

	if (isErrorImg) console.error('Error loading resource image', errorImg?.message)
	if (isErrorPdfFile) console.error('Error loading resource pdf', errorPdfFile?.message)

	return (
		<>
			{/* NOTE: use display flex at the top level to prevent safari from breaking image and card when using columns css  */}
			<div className="flex">
				{show && (
					<ResourcesModal
						show={show}
						handleClose={handleClose}
						title={title}
						isLoading={isLoadingPdfFile}
						pdf={pdfFile}
					/>
				)}

				<Card className={`w-full !overflow-hidden ${className}`} onClick={handleShow}>
					<div>
						{isLoadingImg && <div className="skeleton h-[320px] w-full" />}

						{!isLoadingImg && cover && (
							<img
								src={imageUrl}
								alt={cover?.alternativeText ?? title}
								className="h-auto w-full bg-[#d0dae6] object-cover"
							/>
						)}

						{!isLoadingPdfFile && !cover && (
							<div className={`${thumbnailClassName} mx-auto`}>
								<PdfThumbnail fileUrl={pdfFile} />
							</div>
						)}
					</div>

					<div className="min-h-[123px] px-4 pb-6 pt-4">
						<p className="text-dark mb-1 text-xl font-semibold leading-snug">{title}</p>
						<p className="line-clamp-2 overflow-hidden text-ellipsis">{dek}</p>
					</div>
				</Card>
			</div>
		</>
	)
}

export default ResourcesCard
